import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {Link} from 'react-router-dom';
import {getAdminEmpresa, getOperadorRemarcacao, getFinanceiroCaixa,
getFinanceiroEmpresa,
getOperadorEmpresa,
getPerfisVendedores, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {apenasNumero, renderFieldCpf, renderFieldNumber} from '../../util/inputs';
import Titulo from '../comum/Titulo';
import buscarPedidoExcessoBagagem from '../../actions/bagagem/buscarReservasExcessoBagagem';
import alterarMarcacaoReservaExcessoBagagem from '../../actions/bagagem/alterarMarcacaoReservaExcessoBagagem';
import limparReservasExcessoBagagem from '../../actions/bagagem/limparReservasExcessoBagagem';
import selecionarReservasExcessoBagagem from '../../actions/bagagem/selecionarReservasExcessoBagagem';
import limpaViagens from '../../actions/viagem/limpaViagens';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda'
import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import selecionarViagemVolta from '../../actions/viagem/selecionarViagemVolta';
import {showErrorMsg} from '../../util/messagesUtil';
import Bilhete from './Bilhete';

const selector = formValueSelector('formRemarcacao');

export const CabecalhoTabela = () => (
  <div className="vx-list-header vx-list-header--bilhete">
    <div className="vx-list-header-cell">Empresa</div>
    <div className="vx-list-header-cell">Nome</div>
    <div className="vx-list-header-cell">CPF</div>
    <div className="vx-list-header-cell">Data embarque</div>
    <div className="vx-list-header-cell">Origem / Destino</div>
    <div className="vx-list-header-cell">Delimitação</div>
    <div className="vx-list-header-cell">Embarcou</div>
    <div className="vx-list-header-cell">Situação</div>
    <div className="vx-list-header-cell">Pedido</div>
    <div className="vx-list-header-cell">Poltrona</div>
  </div>
);

export class PesquisarBilhete extends React.Component {
    constructor(props) {
        super(props);
        this.montarParametroPedido = this.montarParametroPedido.bind(this);
        this.state = { custoCancelamento: '0' };
    }

    componentDidMount() {
        this.props.limparReservasExcessoBagagem();
        this.buscarPedidos();
        this.props.selecionarReservasExcessoBagagem();
        this.limparTudo();
    }

    limparTudo() {
        this.props.selecionarDestino(null);
        this.props.selecionarOrigem(null);
        this.props.limpaViagens();
        this.props.selecionarViagemIda();
        this.props.selecionarViagemVolta();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.selecionarReservasExcessoBagagem(null);
        this.props.adicionarFormasPagamento(null);
        this.props.selecionarDescontoUsuario({ ida: 0.00, volta: 0.00 });
    }

    buscarPedidos() {
        const parametros = {
            idReserva: this.props.numeroBilhete && this.props.numeroBilhete !== '' ? this.props.numeroBilhete : null,
            idPedido: this.props.numeroPedido && this.props.numeroPedido !== '' ? this.props.numeroPedido.trim() : null,
            cpf: this.props.cpf && this.props.cpf !== '' ? apenasNumero(this.props.cpf) : null,
            idEmpresa: this.props.empresaSelecionada.id,
        }
        this.props.buscarPedidoExcessoBagagem(parametros);
    }

    limparPesquisas() {
        this.props.limparReservasExcessoBagagem();
        this.props.selecionarReservasExcessoBagagem();
    }

    // eslint-disable-next-line class-methods-use-this
    montarParametroPedido(values) {
        return {
            id: values.idPedido,
            nome: values.nome,
            telefones: [values.ddd + values.celular],
            email: values.email
        };
    }

    alterarMarcacao(reserva) {
        const reservasSelecionadas = this.props.reservas.filter(f => f.selecionada);
        if (reservasSelecionadas.length > 0) {
            const pedidoId = reservasSelecionadas[0].pedidoId;
            if (pedidoId === reserva.pedidoId) {
                this.props.alterarMarcacaoReservaExcessoBagagem(reserva);
            } else {
                showErrorMsg('Selecione reservas do mesmo pedido.');
            }
        } else {
            this.props.alterarMarcacaoReservaExcessoBagagem(reserva);
        }
    }

    selecionarReservas() {
        const reservas = this.props.reservas.filter(f => f.selecionada);
        this.props.selecionarReservasExcessoBagagem(reservas);
    }

    exibirReservas() {
        return this.props.reservas.map((reserva, index) => (
            <Bilhete key={reserva.id} reserva={reserva}
                     empresaSelecionada={this.props.empresaSelecionada}
                     alterarMarcacaoReserva={this.alterarMarcacao.bind(this)}
                     indice={index}/>
        ));
    }

    exibirTipoBusca() {
        return (
            <div className="col-12" style={{marginBottom: 16}}>
                <div className="vx-search-card">
                    <div className="vx-search-card-title">
                        <span className="material-icons">search</span>
                        Pesquisar bilhete
                    </div>
                    <div className="vx-search-row">
                        <div className="vx-search-field" onClick={() => {
                            this.limparPesquisas();
                            this.props.changeFieldValue('formRemarcacao', 'cpf', null);
                            this.props.changeFieldValue('formRemarcacao', 'numeroBilhete', null);
                        }}>
                            <label>Número do pedido</label>
                            <Field name='numeroPedido' type="text" css="form-control"
                                   component={renderFieldNumber}
                                   onChange={() => this.limparPesquisas()}
                                   placeholder="Ex: 12345"/>
                        </div>
                        <div className="vx-search-sep">ou</div>
                        <div className="vx-search-field" onClick={() => {
                            this.limparPesquisas();
                            this.props.changeFieldValue('formRemarcacao', 'numeroPedido', null);
                            this.props.changeFieldValue('formRemarcacao', 'numeroBilhete', null);
                        }}>
                            <label>CPF do passageiro</label>
                            <Field name='cpf' type="text" css="form-control"
                                   component={renderFieldCpf}
                                   onChange={() => this.limparPesquisas()}
                                   placeholder="000.000.000-00"/>
                        </div>
                        <div className="vx-search-sep">ou</div>
                        <div className="vx-search-field" onClick={() => {
                            this.limparPesquisas();
                            this.props.changeFieldValue('formRemarcacao', 'cpf', null);
                            this.props.changeFieldValue('formRemarcacao', 'numeroPedido', null);
                        }}>
                            <label>Número do bilhete</label>
                            <Field name='numeroBilhete' type="text" css="form-control"
                                   component={renderFieldNumber}
                                   onChange={() => this.limparPesquisas()}
                                   placeholder="Ex: 67890"/>
                        </div>
                        <button type="button" className="vx-search-btn" onClick={() => this.buscarPedidos()}>
                            <span className="material-icons">search</span>
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    exibirBotoes() {
        if (!this.props.reservas) {
            return null;
        }
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        if (selecionadas.length > 0) {
            return (
                <div className="col-12">
                    <div className="vx-search-action-bar">
                        <Link to="/painel-cadastro-bagagem">
                            <button type="button" className="vx-search-include-btn"
                                    onClick={() => this.selecionarReservas()}>
                                <span className="material-icons">add</span>
                                Incluir Bagagem ({selecionadas.length} reserva{selecionadas.length > 1 ? 's' : ''})
                            </button>
                        </Link>
                    </div>
                </div>
            );
        }
        return null;
    }

    exibirTabelaReservas() {
        if (this.props.reservas && this.props.reservas.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoTabela/>
                    {this.exibirReservas()}
                </div>
            );
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">confirmation_number</span>
                    <p>Nenhuma reserva localizada. Verifique os parâmetros informados.</p>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="row internas">
                <Titulo texto="Menu Bagagem" urlRetorno="/menu-bagagem"/>
                <div className='col-12 conteudo-internas conteudo-painel'>
                    <div className="row">
                        {this.exibirTipoBusca()}
                        <Autorizacao
                            perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
                                getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                                getOperadorEmpresa(this.props.empresaSelecionada.id),
                                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                                getOperadorRemarcacao(this.props.empresaSelecionada.id),
                                getFinanceiroCaixa(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                            empresaSelecionada={this.props.empresaSelecionada}>
                            {this.exibirBotoes()}
                        </Autorizacao>
                    </div>
                    {this.exibirTabelaReservas()}
                </div>
            </div>
        );
    }
}


export const mapStateToProps = state => ({
    reservas: state.reservasExcessoBagagem.reservas,
    reservasSelecionadas: state.reservasExcessoBagagem.reservasSelecionadas,
    empresaSelecionada: state.empresaSelecionada,
    tipoPesquisa: selector(state, 'tipoPesquisa'),
    cpf: selector(state, 'cpf'),
    numeroPedido: selector(state, 'numeroPedido'),
    numeroBilhete: selector(state, 'numeroBilhete')
});


export default connect(mapStateToProps, {
    alterarMarcacaoReservaExcessoBagagem,
    buscarPedidoExcessoBagagem,
    limparReservasExcessoBagagem,
    selecionarReservasExcessoBagagem,
    limpaViagens,
    selecionarDestino,
    selecionarOrigem,
    adicionarPassageirosIda,
    adicionarPassageirosVolta,
    selecionarDescontoUsuario,
    adicionarFormasPagamento,
    selecionarViagemIda,
    selecionarViagemVolta,
    changeFieldValue
})(reduxForm({
    form: 'formRemarcacao',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PesquisarBilhete));
